import Navbar from "../../../components/Navbar/Navbar";
import Sidebar from "../../../components/SideBar/sidebar";
import BasicDetails from "../../../components/Profile/BasicDetails";
import BusinessProof from "../../../components/Profile/BusinessProof";
import ChangePassword from "../../../components/Profile/ChangePassword";
import MySubscription from "../../../components/Profile/MySubscription";
import ShopDetails from "../../../components/Profile/ShopDetails";
import React, { useEffect, useState } from "react";
import image from "../../../assets/Images/roundimage.png";
import { Image } from "antd";
import { Breadcrumb } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import { routes } from "../../../Routes";
import { useSelector } from "react-redux";
import BDODetails from "../../../components/Profile/BDODetails";
import { store } from "../../../Redux/store";
import { useTranslation } from "react-i18next";
import "../../../styles.css";
import { GetRetailerDetails } from "../../../API  Functions/ProfileFunctions";
import ShopLocation from "../../../components/Profile/ShopLocation";
import BasicCashierSettings from "../../../components/CashierSetup/BasicCashierSettings";
import CashierModulesAccess from "../../../components/CashierSetup/CashierModulesAccess";
import DeliveryCompanySetup from "../../../components/CashierSetup/DeliveryCompanySetup";
import CashierReceiptFormat from "../../../components/CashierSetup/CashierReceiptFormat";
import OrderReceipt from "../../../components/CashierSetup/CashierReceiptFormat";

const CashierSetupScreen = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector((state) => state.login?.user?.store_id);
  const company_name = useSelector(
    (state) => state?.login?.user?.result?.company_name
  );
  const image_url = useSelector(
    (state) => state?.login?.user?.result?.image_url
  );
  const [retailerData, setretailerData] = useState({});
  const [selectedValue, setSelectedValue] = useState("Basic Settings");

  useEffect(() => {
    fetchdetails();
  }, []);

  const fetchdetails = () => {
    GetRetailerDetails(user_id).then((result) => {
      if (result) {
        setretailerData(result?.retailer_details);
      }
    });
  };

  const data = [
    {
      name: "Basic Settings",
      component: (
        <BasicCashierSettings retailerDetails={retailerData} />
      ),
    },
    {
      name: "Cashier Module Access",
      component: (
        <CashierModulesAccess />
      ),
    },
    {
      name: "Delivery Company Setup",
      component: (
        <DeliveryCompanySetup retailerDetails={retailerData} />
      ),
    },
    {
      name: "View Receipt Format",
      component: (
        <OrderReceipt retailerDetails={retailerData} />
      ),
    },

  ];
  //
  return (
    <>
      <div className="w-full flex flex-col pb-2 overflow-y-auto  bg-[#F6F7F9]">
        <Navbar heading="Cashier Setup" />
        <div className="overflow-y-auto custom-scrollbar">
          {/* <div className="flex flex-col bg-[#F6F7F9] flex-1 min-h-screen overflow-y-auto custom-scrollbar"> */}
          {/* <div className="mx-5 font-extrabold">
          <Breadcrumb
            separator={<DoubleRightOutlined />}
            items={[
              {
                title: t("settings"),
                //  href: routes.settings.profile
              },
              { title: t("Cashier Setup") },
            ]}
            className="relative top-3"
          />
        </div> */}
          <div
            className="mx-3 sm:mx-3 mt-4 mb-10 bg-white rounded-xl overflow-y-auto custom-scrollbar"
            style={{ minWidth: 700 }}
          >
            <div className="flex ">
              {/* <div className="md:w-[24%] pb-6 border-r-2 text-[#929EAE] flex flex-col text-center items-center font-medium text-lg"> */}
              <div
                className={`md:w-[24%] pb-6 text-[#929EAE] flex flex-col font-medium text-lg ${i18n.language === "ar" ? "border-l-2" : "border-r-2"
                  }`}
              >
                <div className="mt-4 flex flex-col gap-2 justify-center items-center">
                </div>
                {data.map((val, i) => (
                  <div className="cursor-pointer w-full " key={i}>
                    <div
                      className={`py-3 px-4 text-md ${selectedValue === val.name
                        ? "bg-[#D1F1FC] text-black"
                        : "bg-[white]"
                        }`}
                      onClick={() => setSelectedValue(val.name)}
                    >
                      {t(val.name)}
                    </div>
                  </div>
                ))}
              </div>
              <div className="overflow-y-auto custom-scrollbar w-full sm:w-[76%] mx-auto">
                {data.map((val, i) => (
                  <div
                    key={i}
                    style={{
                      display: val.name === selectedValue ? "block" : "none",
                    }}
                  >
                    {val?.component}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CashierSetupScreen;
